import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackEvent } from '../lib/analytics';
import { useTrainingSession } from './session';

export function TrainingPlans() {
  const { persona } = useTrainingSession();
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent('upgrade_panel_viewed', { source: 'plans_page' });
  }, []);

  const isPro = persona === 'pro-learner' || persona === 'manager';

  return (
    <div className="tr-root">
      <div className="tr-wrap tr-appsec">
        <button className="tr-back" onClick={() => navigate('/training/catalog')}>
          <i className="ti ti-arrow-left"></i> Back to training
        </button>
        <h1 className="tr-h1">Open the rest of the training</h1>
        <p className="tr-sub">
          Module 1 is free and stays free. Everything beyond it comes with
          Pro, which covers a whole team on one plan.
        </p>

        <div className="tr-plans" style={{ marginTop: 28 }}>
          <div className="tr-plan">
            <div className="tr-plan-tag">{!isPro ? 'Your plan' : ''}</div>
            <h3>Free</h3>
            <p className="tr-lede">What you have now.</p>
            <ul>
              <li><i className="ti ti-check"></i>Module 1, complete</li>
              <li><i className="ti ti-check"></i>Knowledge check and your progress</li>
              <li><i className="ti ti-check"></i>Scam Checker and fraud alerts</li>
            </ul>
            <button className="tr-btn tr-btn-ghost" disabled>
              {isPro ? 'Not your plan' : 'Current plan'}
            </button>
          </div>
          <div className="tr-plan tr-hot">
            <div className="tr-plan-tag">Bought by managers</div>
            <h3>Pro</h3>
            <p className="tr-lede">
              The full curriculum for everyone who works for you, plus the
              tools to prove they did it.
            </p>
            <ul>
              <li><i className="ti ti-check"></i>All eight modules, for every person on the team</li>
              <li><i className="ti ti-check"></i>New modules as they're released</li>
              <li><i className="ti ti-check"></i>Assign modules with due dates</li>
              <li><i className="ti ti-check"></i>Team completion dashboard</li>
              <li><i className="ti ti-check"></i>Exportable completion records</li>
            </ul>
            {isPro ? (
              <button className="tr-btn tr-btn-ghost" disabled>Current plan</button>
            ) : (
              <button
                className="tr-btn tr-btn-primary"
                onClick={() => trackEvent('plan_selected', { plan: 'pro' })}
              >
                Talk to us about Pro <i className="ti ti-arrow-right"></i>
              </button>
            )}
            <p className="tr-after">Priced per person on the team. Tell us how many and we'll size it.</p>
          </div>
        </div>

        <div className="tr-truth">
          Completion is completion. A module counts as done when every
          lesson has been worked through and the knowledge check is passed —
          so the records you export mean something.
        </div>
      </div>
    </div>
  );
}
